var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textfield-screen',{attrs:{"id":"firstName","title":_vm.$ml.get('setLastNameReg'),"is-not-valid":_vm.isNotValid,"is-not-valid-message":_vm.isNotValidMessage,"maxlength":30,"headerImg":3,"disabledNextButton":_vm.disabled},on:{"next":_vm.nextScreen,"back":_vm.back},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})
}
var staticRenderFns = []

export { render, staticRenderFns }